// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Notification.css */
.notification {
  display: flex;
  align-items: center;
  background-color: #f4f4f8;
  border-radius: 12px;
  box-shadow: 0px 2px 8px rgba(0,0,0,0.2);
  padding: 10px 16px;
  max-width: 360px;
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
  /* font-family: -apple-system, BlinkMacSystemFont, sans-serif; */
  font-family: "Poppins", sans-serif;
}
 
.notification-icon img {
  width: 36px;
  height: 36px;
  border-radius: 6px;
}
 
.notification-content {
  flex: 1 1;
  margin: 0 12px;
}
 
.notification-name {
  font-weight: 600;
  font-size: 14px;
}
 
.notification-message {
  font-size: 13px;
  color: #333;
}
 
.notification-actions button {
  background: #f1f1f1;
  border: none;
  border-radius: 6px;
  padding: 6px 10px;
  cursor: pointer;
  font-size: 13px;
}
 
 `, "",{"version":3,"sources":["webpack://./src/helpers/Notification.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,WAAW;EACX,aAAa;EACb,gEAAgE;EAChE,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB","sourcesContent":["/* Notification.css */\n.notification {\n  display: flex;\n  align-items: center;\n  background-color: #f4f4f8;\n  border-radius: 12px;\n  box-shadow: 0px 2px 8px rgba(0,0,0,0.2);\n  padding: 10px 16px;\n  max-width: 360px;\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  z-index: 9999;\n  /* font-family: -apple-system, BlinkMacSystemFont, sans-serif; */\n  font-family: \"Poppins\", sans-serif;\n}\n \n.notification-icon img {\n  width: 36px;\n  height: 36px;\n  border-radius: 6px;\n}\n \n.notification-content {\n  flex: 1;\n  margin: 0 12px;\n}\n \n.notification-name {\n  font-weight: 600;\n  font-size: 14px;\n}\n \n.notification-message {\n  font-size: 13px;\n  color: #333;\n}\n \n.notification-actions button {\n  background: #f1f1f1;\n  border: none;\n  border-radius: 6px;\n  padding: 6px 10px;\n  cursor: pointer;\n  font-size: 13px;\n}\n \n "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
